(function () {
  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function closeDrawers() {
    document.body.classList.remove('menu-open');
    document.body.classList.remove('filter-open');
    document.body.classList.remove('cart-open');
    document.body.classList.remove('wishlist-open');
    document.body.classList.remove('search-open');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-drawer-open]');
    if (trigger) {
      event.preventDefault();
      document.body.classList.add(trigger.getAttribute('data-drawer-open'));
      return;
    }

    if (event.target.closest('[data-drawer-close]') || event.target.classList.contains('drawer-overlay')) {
      closeDrawers();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawers();
      var imageModal = qs('[data-product-image-modal]');
      if (imageModal) imageModal.hidden = true;
    }
  });

  qsa('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      select.closest('form').submit();
    });
  });

  qsa('[data-mobile-view]').forEach(function (button) {
    button.addEventListener('click', function () {
      var mode = button.getAttribute('data-mobile-view') || 'grid';
      var wrap = button.closest('[data-collection-products]') || document;
      var grid = qs('[data-infinite-grid]', wrap);
      if (!grid) return;
      grid.setAttribute('data-mobile-grid-mode', mode);
      qsa('[data-mobile-view]', wrap).forEach(function (item) {
        item.classList.toggle('is-active', item === button);
      });
    });
  });

  qsa('[data-price-filter]').forEach(function (filter) {
    var minSlider = qs('[data-price-min-range]', filter);
    var maxSlider = qs('[data-price-max-range]', filter);
    var minInput = qs('[data-price-min]', filter);
    var maxInput = qs('[data-price-max]', filter);
    var label = qs('[data-price-label]', filter);
    var rangeTrack = qs('.price-filter__range', filter);
    var rangeMax = parseInt(filter.getAttribute('data-range-max') || '0', 10);
    if (!minSlider || !maxSlider || !minInput || !maxInput) return;

    function syncPrice() {
      var minValue = parseInt(minSlider.value || '0', 10);
      var maxValue = parseInt(maxSlider.value || rangeMax || '0', 10);
      if (minValue > maxValue) {
        if (document.activeElement === minSlider) {
          maxValue = minValue;
          maxSlider.value = maxValue;
        } else {
          minValue = maxValue;
          minSlider.value = minValue;
        }
      }
      minInput.value = minValue;
      maxInput.value = maxValue;
      var start = rangeMax ? (minValue / rangeMax) * 100 : 0;
      var end = rangeMax ? (maxValue / rangeMax) * 100 : 100;
      (rangeTrack || filter).style.setProperty('--price-start', start + '%');
      (rangeTrack || filter).style.setProperty('--price-end', end + '%');
      if (label) {
        label.innerHTML = '<span>&#8377;' + minValue + '</span><span>&#8377;' + maxValue + (maxValue >= rangeMax ? '+' : '') + '</span>';
      }
    }

    minSlider.addEventListener('input', syncPrice);
    maxSlider.addEventListener('input', syncPrice);
    syncPrice();
  });

  qsa('[data-infinite-grid]').forEach(function (grid) {
    var pagination = qs('[data-infinite-pagination]');
    var loading = qs('[data-infinite-loading]');
    if (!pagination || !window.IntersectionObserver) return;
    var isLoading = false;

    function getNextLink() {
      var direct = qs('a[rel="next"]', pagination);
      if (direct) return direct.href;
      var next = qsa('a', pagination).find(function (link) {
        return /next|›|»/i.test(link.textContent || '');
      });
      return next ? next.href : null;
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; }) || isLoading) return;
      var nextUrl = getNextLink();
      if (!nextUrl) {
        observer.disconnect();
        pagination.hidden = true;
        return;
      }
      isLoading = true;
      if (loading) loading.hidden = false;
      fetch(nextUrl)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = qs('[data-infinite-grid]', doc);
          var nextPagination = qs('[data-infinite-pagination]', doc);
          if (nextGrid) {
            qsa('.product-card', nextGrid).forEach(function (card) {
              grid.appendChild(document.importNode(card, true));
            });
          }
          if (nextPagination) {
            pagination.innerHTML = nextPagination.innerHTML;
          } else {
            pagination.hidden = true;
            observer.disconnect();
          }
          initWishlistButtons();
        })
        .finally(function () {
          isLoading = false;
          if (loading) loading.hidden = true;
        });
    }, { rootMargin: '900px 0px' });
    observer.observe(pagination);
  });

  qsa('[data-delivery-check]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = qs('input', form);
      var result = qs('[data-delivery-result]', form.parentElement);
      if (!result || !input) return;
      var pin = input.value.trim();
      if (/^[1-9][0-9]{5}$/.test(pin)) {
        result.textContent = 'Delivery available. COD and 7-day returns may be available for this pincode.';
      } else {
        result.textContent = 'Please enter a valid 6 digit Indian pincode.';
      }
    });
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-discount-apply]');
    if (!button) return;
    var scope = button.closest('[data-discount-scope]') || button.closest('form') || document;
    var input = qs('[data-discount-input]', scope);
    var message = qs('[data-discount-message]', scope);
    if (!input || !message) return;
    event.preventDefault();
    var code = input.value.trim();
    if (!code) {
      message.textContent = 'Please enter a discount code.';
      message.classList.remove('is-success');
      message.classList.add('is-error');
      return;
    }
    button.disabled = true;
    message.textContent = 'Applying discount code...';
    message.classList.remove('is-error', 'is-success');
    updateCartDiscount(code, button, message, scope);
  });

  document.addEventListener('click', function (event) {
    var clearButton = event.target.closest('[data-discount-clear]');
    if (!clearButton) return;
    event.preventDefault();
    clearButton.disabled = true;
    clearButton.textContent = 'Removing...';
    rememberDiscountCode('');
    updateCartDiscount('', clearButton, null, clearButton.closest('.cart-drawer') || clearButton.closest('[data-cart-page]') || document);
  });

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest('button[name="checkout"], .cart-drawer__checkout');
    if (!checkoutButton) return;
    var code = activeDiscountCode();
    if (!code) return;
    event.preventDefault();
    window.location.href = checkoutUrlWithDiscount(code);
  });

  document.addEventListener('click', function (event) {
    var openOffers = event.target.closest('[data-offers-open]');
    if (openOffers) {
      event.preventDefault();
      var modal = qs('[data-offers-modal]');
      if (modal) modal.hidden = false;
      return;
    }

    var closeOffers = event.target.closest('[data-offers-close]');
    var offersModal = qs('[data-offers-modal]');
    if (closeOffers || (offersModal && !offersModal.hidden && event.target === offersModal)) {
      if (offersModal) offersModal.hidden = true;
      return;
    }

    var copyCode = event.target.closest('[data-copy-code]');
    if (!copyCode) return;
    event.preventDefault();
    var code = copyCode.getAttribute('data-copy-code') || '';
    var done = function () {
      copyCode.classList.add('is-copied');
      copyCode.setAttribute('data-copied-text', 'Copied');
      setTimeout(function () {
        copyCode.classList.remove('is-copied');
        copyCode.removeAttribute('data-copied-text');
      }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(done);
    } else {
      var tempInput = document.createElement('input');
      tempInput.value = code;
      document.body.appendChild(tempInput);
      tempInput.select();
      try { document.execCommand('copy'); } catch (error) {}
      tempInput.remove();
      done();
    }
  });

  function formatMoney(cents) {
    var amount = (parseInt(cents || 0, 10) / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return '₹ ' + amount;
  }

  function cartImageUrl(item) {
    if (!item || !item.image) return '';
    return item.image.indexOf('//') === 0 ? 'https:' + item.image : item.image;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  var activeDiscountStorageKey = 'ampkActiveDiscountCode';

  function rememberDiscountCode(code) {
    try {
      if (code) {
        window.sessionStorage.setItem(activeDiscountStorageKey, code);
        window.localStorage.setItem(activeDiscountStorageKey, code);
      } else {
        window.sessionStorage.removeItem(activeDiscountStorageKey);
        window.localStorage.removeItem(activeDiscountStorageKey);
      }
    } catch (error) {}
  }

  function activeDiscountCode() {
    try {
      return window.sessionStorage.getItem(activeDiscountStorageKey) || window.localStorage.getItem(activeDiscountStorageKey) || '';
    } catch (error) {
      return '';
    }
  }

  function checkoutUrlWithDiscount(code) {
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout');
  }

  function cartOriginalTotal(cart) {
    if (!cart) return 0;
    if (cart.original_total_price) return cart.original_total_price;
    if (cart.items_subtotal_price) return cart.items_subtotal_price;
    return (cart.total_price || 0) + (cart.total_discount || 0);
  }

  function cartDiscountNames(cart) {
    var names = [];
    var seen = {};
    function addName(value) {
      if (!value || seen[value]) return;
      seen[value] = true;
      names.push(value);
    }
    (cart.cart_level_discount_applications || []).forEach(function (discount) {
      addName(discount.title || discount.code);
    });
    (cart.items || []).forEach(function (item) {
      (item.discounts || []).forEach(function (discount) {
        addName(discount.title || discount.code);
      });
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        var application = allocation.discount_application || {};
        addName(application.title || application.code);
      });
    });
    return names;
  }

  function hasDiscountCode(cart, code) {
    var normalized = String(code || '').trim().toLowerCase();
    if (!normalized) return false;
    return cartDiscountNames(cart).some(function (name) {
      return String(name || '').trim().toLowerCase() === normalized;
    });
  }

  function offerByCode(code) {
    var normalized = String(code || '').trim().toLowerCase();
    var match = null;
    if (!normalized) return null;
    qsa('[data-copy-code]').some(function (button) {
      if (String(button.getAttribute('data-copy-code') || '').trim().toLowerCase() === normalized) {
        match = {
          code: button.getAttribute('data-copy-code') || '',
          min_quantity: parseInt(button.getAttribute('data-offer-min-quantity') || '0', 10),
          min_cart_amount: parseInt(button.getAttribute('data-offer-min-amount') || '0', 10)
        };
        return true;
      }
      return false;
    });
    return match;
  }

  function offerConditionMessage(offer, cart, code) {
    return code + ' Coupon code applied does not met Cart Conditions';
  }

  function findDiscountMessage(scope) {
    if (scope && scope.classList && scope.classList.contains('cart-drawer')) {
      return qs('.cart-drawer [data-discount-message]');
    }
    if (scope && scope.closest && scope.closest('.cart-drawer')) {
      return qs('.cart-drawer [data-discount-message]');
    }
    if (scope && scope.closest && scope.closest('[data-cart-page]')) {
      return qs('[data-cart-page] [data-discount-message]');
    }
    return qs('[data-discount-message]');
  }

  function setDiscountMessage(message, text, status) {
    if (!message) return;
    message.textContent = text;
    message.classList.remove('is-error', 'is-success');
    if (status) message.classList.add(status);
    var details = message.closest('details');
    if (details) details.open = true;
  }

  function cartSummaryHtml(cart, totalLabel, pageClass) {
    var baseClass = pageClass || 'cart-drawer';
    var discount = parseInt(cart && cart.total_discount ? cart.total_discount : 0, 10);
    var html = '';
    if (discount > 0) {
      html += '<div class="' + baseClass + '__summary-row"><span>Order total</span><strong>' + formatMoney(cartOriginalTotal(cart)) + '</strong></div>';
      cartDiscountNames(cart).forEach(function (name) {
        html += '<div class="' + baseClass + '__summary-row ' + baseClass + '__summary-row--code"><span>Offer applied</span><strong>' + escapeHtml(name) + '</strong></div>';
      });
      html += '<div class="' + baseClass + '__summary-row ' + baseClass + '__summary-row--discount"><span>Discount value</span><strong>-' + formatMoney(discount) + '</strong></div>';
      html += '<button class="cart-discount-clear" type="button" data-discount-clear>Remove discount</button>';
    }
    html += '<div class="' + baseClass + '__total"><span>' + (totalLabel || 'Estimated total') + '</span><strong data-cart-total>' + formatMoney(cart.total_price) + '</strong></div>';
    return html;
  }

  function cartPageSummaryHtml(cart, totalLabel) {
    var discount = parseInt(cart && cart.total_discount ? cart.total_discount : 0, 10);
    var html = '';
    if (discount > 0) {
      html += '<div class="cart-page-summary__row"><span>Order total</span><strong>' + formatMoney(cartOriginalTotal(cart)) + '</strong></div>';
      cartDiscountNames(cart).forEach(function (name) {
        html += '<div class="cart-page-summary__row cart-page-summary__row--code"><span>Offer applied</span><strong>' + escapeHtml(name) + '</strong></div>';
      });
      html += '<div class="cart-page-summary__row cart-page-summary__row--discount"><span>Discount value</span><strong>-' + formatMoney(discount) + '</strong></div>';
      html += '<button class="cart-discount-clear" type="button" data-discount-clear>Remove discount</button>';
    }
    html += '<div class="cart-page-total">' + (totalLabel || 'Total') + ': <span data-cart-page-total>' + formatMoney(cart.total_price) + '</span></div>';
    return html;
  }

  function updateCartDiscount(code, button, message, scope) {
    var originalText = button ? button.textContent : '';
    var formData = new FormData();
    formData.append('discount', code);
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Discount update failed');
        return response.json();
      })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateCartPage(cart);
        renderAccountCart(cart);
        var currentMessage = message && message.isConnected ? message : findDiscountMessage(scope);
        if (code) {
          var knownOffer = offerByCode(code);
          if (hasDiscountCode(cart, code)) {
            rememberDiscountCode(code);
            setDiscountMessage(currentMessage, 'Coupon code applied successfully.', 'is-success');
          } else if (knownOffer && parseInt(cart && cart.total_discount ? cart.total_discount : 0, 10) > 0) {
            rememberDiscountCode(code);
            setDiscountMessage(currentMessage, 'Coupon code applied successfully.', 'is-success');
          } else if (knownOffer) {
            rememberDiscountCode('');
            setDiscountMessage(currentMessage, offerConditionMessage(knownOffer, cart, code), 'is-error');
          } else {
            rememberDiscountCode('');
            setDiscountMessage(currentMessage, code + ' Coupon code applied does not exist.', 'is-error');
          }
        } else {
          rememberDiscountCode('');
          setDiscountMessage(currentMessage, 'Discount removed.', 'is-success');
        }
      })
      .catch(function () {
        rememberDiscountCode('');
        var currentMessage = message && message.isConnected ? message : findDiscountMessage(scope);
        setDiscountMessage(currentMessage, 'Could not update discount. Please try again.', 'is-error');
      })
      .finally(function () {
        if (!button) return;
        button.disabled = false;
        if (originalText) button.textContent = originalText;
      });
  }

  function renderCartDrawer(cart) {
    var drawer = qs('[data-cart-drawer]');
    if (!drawer || !cart) return;
    var body = qs('[data-cart-drawer-body]', drawer);
    var count = cart.item_count || 0;
    qsa('.cart-count, [data-cart-count]').forEach(function (item) {
      item.textContent = count;
    });
    if (!body) return;

    if (!count) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>' + (drawer.getAttribute('data-empty-text') || 'Your cart is empty.') + '</p><a class="ampk-btn ampk-btn--dark" href="' + (drawer.getAttribute('data-empty-link') || '/collections/all') + '">' + (drawer.getAttribute('data-empty-button') || 'Start Shopping') + '</a></div>';
      return;
    }

    var itemsHtml = cart.items.map(function (item, index) {
      var image = cartImageUrl(item);
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-drawer__variant">' + item.variant_title + '</div>' : '';
      return '<div class="cart-drawer__item" data-cart-drawer-item data-line="' + (index + 1) + '" data-cart-key="' + item.key + '">' +
        (image ? '<a href="' + item.url + '"><img src="' + image + '" alt="" width="70" height="92"></a>' : '') +
        '<div class="cart-drawer__item-info">' +
        '<a class="cart-drawer__item-title" href="' + item.url + '">' + item.product_title + '</a>' +
        variant +
        '<div class="cart-drawer__price">' + formatMoney(item.final_price) + '</div>' +
        '<div class="cart-drawer__qty"><button type="button" data-qty-minus aria-label="Decrease quantity">-</button><input name="updates[]" value="' + item.quantity + '" min="0" type="number" aria-label="Quantity"><button type="button" data-qty-plus aria-label="Increase quantity">+</button></div>' +
        '<a class="cart-drawer__remove" href="/cart/change?line=' + (index + 1) + '&quantity=0" data-cart-remove="' + (index + 1) + '" data-cart-key="' + item.key + '" aria-label="Remove ' + item.product_title + '"><i class="ti ti-trash" aria-hidden="true"></i><span>Remove</span></a>' +
        '</div></div>';
    }).join('');

    var discountHtml = drawer.getAttribute('data-show-discount') === 'true'
      ? '<details class="cart-drawer__discount" data-discount-scope><summary>' + (drawer.getAttribute('data-discount-label') || 'Discount') + '</summary><button class="cart-drawer__offers" type="button" data-offers-open>View Offers</button><div class="cart-drawer__discount-row"><input type="text" name="discount" placeholder="' + (drawer.getAttribute('data-discount-placeholder') || 'Enter discount code') + '" data-discount-input><button type="button" data-discount-apply>Apply</button></div><div class="cart-drawer__discount-message" data-discount-message></div></details>'
      : '';

    body.innerHTML = '<form action="/cart" method="post" class="cart-drawer__form">' +
      '<div class="cart-drawer__items" data-cart-items>' + itemsHtml + '</div>' +
      '<div class="cart-drawer__footer">' + discountHtml +
      '<div class="cart-drawer__summary" data-cart-summary>' + cartSummaryHtml(cart, drawer.getAttribute('data-total-label') || 'Estimated total') + '</div>' +
      '<p>' + (drawer.getAttribute('data-tax-text') || 'Duties and taxes included. Shipping is calculated at checkout.') + '</p>' +
      '<button class="cart-drawer__checkout" type="submit" name="checkout">' + (drawer.getAttribute('data-checkout-label') || 'Check out') + '</button>' +
      '</div></form>';
  }

  function renderAccountCart(cart) {
    qsa('[data-account-cart]').forEach(function (wrap) {
      if (!cart || !cart.item_count) {
        wrap.innerHTML = '<p class="account-sync-empty">Your cart bag is empty right now.</p>';
        return;
      }
      wrap.innerHTML = cart.items.map(function (item) {
        var image = cartImageUrl(item);
        return '<div class="account-sync-item">' +
          (image ? '<a href="' + item.url + '"><img src="' + image + '" alt=""></a>' : '<span></span>') +
          '<a href="' + item.url + '"><strong>' + item.product_title + '</strong><span>Qty ' + item.quantity + ' - ' + formatMoney(item.final_line_price) + '</span></a>' +
          '<button type="button" data-cart-remove="' + item.key + '" data-cart-key="' + item.key + '">Remove</button>' +
          '</div>';
      }).join('');
    });
  }

  function refreshAccountCart() {
    if (!qs('[data-account-cart]')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(renderAccountCart);
  }

  function refreshCartDrawer() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        renderAccountCart(cart);
        return cart;
      });
  }

  function updateCartPage(cart) {
    var page = qs('[data-cart-page]');
    if (!page || !cart) return;
    var rows = qsa('[data-cart-page-item]', page);
    rows.forEach(function (row, index) {
      var item = cart.items[index];
      if (!item) {
        row.remove();
        return;
      }
      row.setAttribute('data-line', index + 1);
      row.setAttribute('data-cart-key', item.key);
      var input = qs('input', row);
      var linePrice = qs('[data-cart-page-line-price]', row);
      var remove = qs('[data-cart-remove]', row);
      if (input) input.value = item.quantity;
      if (linePrice) linePrice.textContent = formatMoney(item.final_line_price);
      if (remove) {
        remove.setAttribute('data-cart-remove', index + 1);
        remove.setAttribute('data-cart-key', item.key);
        remove.href = '/cart/change?line=' + (index + 1) + '&quantity=0';
      }
    });
    var summary = qs('[data-cart-page-summary]', page);
    if (summary) {
      var totalLabel = summary.getAttribute('data-total-label') || 'Total';
      summary.innerHTML = cartPageSummaryHtml(cart, totalLabel);
    } else {
      var total = qs('[data-cart-page-total]', page);
      if (total) total.textContent = formatMoney(cart.total_price);
    }
    qsa('.cart-count, [data-cart-count]').forEach(function (item) {
      item.textContent = cart.item_count || 0;
    });
    renderAccountCart(cart);
    if (!cart.item_count) {
      window.location.reload();
    }
  }

  function changeCartLine(identifier, quantity) {
    var payload = { quantity: Math.max(0, parseInt(quantity || '0', 10)) };
    if (identifier && String(identifier).indexOf(':') > -1) {
      payload.id = String(identifier);
    } else {
      payload.line = parseInt(identifier, 10);
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json();
    });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    var line = remove.getAttribute('data-cart-key') || remove.getAttribute('data-cart-remove');
    remove.style.pointerEvents = 'none';
    changeCartLine(line, 0).then(function (cart) {
      if (remove.classList.contains('cart-page-remove')) {
        updateCartPage(cart);
        return;
      }
      renderCartDrawer(cart);
      renderAccountCart(cart);
      if (!qs('[data-cart-drawer]') && window.location.pathname.indexOf('/cart') === 0) {
        window.location.reload();
      }
    }).catch(function () {
      window.location.href = remove.href;
    });
  });

  document.addEventListener('click', function (event) {
    var plus = event.target.closest('[data-cart-page-plus]');
    var minus = event.target.closest('[data-cart-page-minus]');
    if (!plus && !minus) return;
    var row = event.target.closest('[data-cart-page-item]');
    var input = qs('input', row);
    if (!row || !input) return;
    var quantity = parseInt(input.value || '0', 10) + (plus ? 1 : -1);
    input.value = Math.max(0, quantity);
    changeCartLine(row.getAttribute('data-cart-key') || row.getAttribute('data-line'), input.value).then(function (cart) {
      updateCartPage(cart);
      renderCartDrawer(cart);
    });
  });

  document.addEventListener('click', function (event) {
    var plus = event.target.closest('[data-qty-plus]');
    var minus = event.target.closest('[data-qty-minus]');
    if (!plus && !minus) return;
    var row = event.target.closest('[data-cart-drawer-item]');
    var input = row ? qs('.cart-drawer__qty input', row) : null;
    if (!row || !input) return;
    var quantity = parseInt(input.value || '0', 10) + (plus ? 1 : -1);
    input.value = Math.max(0, quantity);
    changeCartLine(row.getAttribute('data-cart-key') || row.getAttribute('data-line'), input.value).then(function (cart) {
      renderCartDrawer(cart);
      updateCartPage(cart);
    });
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('.cart-drawer__qty input');
    if (!input) return;
    var row = input.closest('[data-cart-drawer-item]');
    if (!row) return;
    changeCartLine(row.getAttribute('data-cart-key') || row.getAttribute('data-line'), input.value).then(function (cart) {
      renderCartDrawer(cart);
      updateCartPage(cart);
    });
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-page-qty] input');
    if (!input) return;
    var row = input.closest('[data-cart-page-item]');
    if (!row) return;
    changeCartLine(row.getAttribute('data-cart-key') || row.getAttribute('data-line'), input.value).then(function (cart) {
      updateCartPage(cart);
      renderCartDrawer(cart);
    });
  });

  qsa('[data-hero-slider]').forEach(function (slider) {
    var track = qs('[data-hero-track]', slider);
    var slides = qsa('.home-hero__slide', slider);
    var dots = qsa('[data-hero-dot]', slider);
    var prev = qs('[data-hero-prev]', slider);
    var next = qs('[data-hero-next]', slider);
    if (!track || slides.length < 2) return;
    var activeIndex = 0;
    var timer;
    var interval = parseInt(slider.getAttribute('data-interval') || '5000', 10);
    var autoplay = slider.getAttribute('data-autoplay') === 'true';

    function goToSlide(index) {
      activeIndex = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[activeIndex].offsetLeft, behavior: 'smooth' });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
      });
    }

    function startAutoplay() {
      if (!autoplay) return;
      window.clearInterval(timer);
      timer = window.setInterval(function () {
        goToSlide(activeIndex + 1);
      }, interval);
    }

    if (prev) prev.addEventListener('click', function () { goToSlide(activeIndex - 1); startAutoplay(); });
    if (next) next.addEventListener('click', function () { goToSlide(activeIndex + 1); startAutoplay(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToSlide(parseInt(dot.getAttribute('data-hero-dot') || '0', 10));
        startAutoplay();
      });
    });
    track.addEventListener('scroll', function () {
      var current = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (current !== activeIndex && slides[current]) {
        activeIndex = current;
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === activeIndex);
        });
      }
    });
    startAutoplay();
  });

  qsa('[data-search-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      document.body.classList.add('search-open');
      window.setTimeout(function () {
        var input = qs('[data-search-input]');
        if (input) input.focus();
      }, 80);
    });
  });

  qsa('[data-search-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      document.body.classList.remove('search-open');
    });
  });

  qsa('[data-search-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      var input = qs('[data-search-input]', form);
      if (!input || !input.value.trim()) {
        event.preventDefault();
        if (input) input.focus();
      }
    });
  });

  var searchTimer;
  qsa('[data-search-input]').forEach(function (input) {
    input.addEventListener('input', function () {
      var query = input.value.trim();
      var results = qs('[data-search-results]');
      window.clearTimeout(searchTimer);
      if (!results) return;
      if (query.length < 2) {
        results.innerHTML = '<p>Start typing to see related products.</p>';
        return;
      }
      searchTimer = window.setTimeout(function () {
        results.innerHTML = '<p>Searching...</p>';
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,body')
          .then(function (response) { return response.json(); })
          .then(function (payload) {
            var searchResults = (((payload || {}).resources || {}).results || {});
            var products = searchResults.products || [];
            var collections = searchResults.collections || [];
            if (!products.length && !collections.length) {
              results.innerHTML = '<p>No matching products found.</p>';
              return;
            }
            var productHtml = products.map(function (product) {
              var image = product.image || '';
              return '<a class="search-result-card" href="' + product.url + '">' +
                (image ? '<img src="' + image + '" alt="">' : '') +
                '<span><strong>' + product.title + '</strong><small>' + (product.price || '') + '</small></span>' +
                '</a>';
            }).join('');
            var collectionHtml = collections.length
              ? '<div class="search-result-group"><strong>Matching collections</strong>' + collections.map(function (collection) {
                return '<a class="search-result-chip" href="' + collection.url + '">' + collection.title + '</a>';
              }).join('') + '</div>'
              : '';
            results.innerHTML = productHtml + collectionHtml;
          })
          .catch(function () {
            results.innerHTML = '<p>Search is not available right now.</p>';
          });
      }, 220);
    });
  });

  function getWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem('ampkWishlist') || '[]');
    } catch (error) {
      return [];
    }
  }

  function setWishlist(items) {
    window.localStorage.setItem('ampkWishlist', JSON.stringify(items));
  }

  function removeProductInfoWishlistIcons() {
    qsa('.product-info [data-wishlist-toggle], .product-info .product-mobile-action--wishlist, .product-info .ti-heart, .product-info button[aria-label*="wishlist" i], .product-info button[aria-label*="wish" i], .product-info a[aria-label*="wishlist" i], .product-info a[aria-label*="wish" i], .product-actions + [data-wishlist-toggle], .product-actions ~ [data-wishlist-toggle], .product-actions ~ .product-mobile-action[data-wishlist-toggle]').forEach(function (item) {
      var removable = item.closest('button, a') || item;
      if (removable.closest('.product-media')) return;
      removable.remove();
    });
    var actions = qs('.product-info .product-actions');
    var delivery = qs('.product-info .delivery-box');
    if (actions && delivery) {
      var node = actions.nextElementSibling;
      while (node && node !== delivery) {
        var next = node.nextElementSibling;
        if (node.matches('[data-wishlist-toggle], .product-mobile-action, button, a') || qs('.ti-heart, [data-wishlist-toggle]', node)) {
          node.remove();
        }
        node = next;
      }
    }
  }

  function watchProductInfoWishlistIcons() {
    var productInfo = qs('.product-info');
    if (!productInfo || !window.MutationObserver) return;
    var observer = new MutationObserver(function () {
      removeProductInfoWishlistIcons();
    });
    observer.observe(productInfo, { childList: true, subtree: true });
  }

  function renderAccountWishlist() {
    var items = getWishlist();
    qsa('[data-account-wishlist]').forEach(function (wrap) {
      if (!items.length) {
        wrap.innerHTML = '<p class="account-sync-empty">Your saved products will appear here after you add items to wishlist.</p>';
        return;
      }
      wrap.innerHTML = items.map(function (item) {
        return '<div class="account-sync-item">' +
          (item.image ? '<a href="' + item.url + '"><img src="' + item.image + '" alt=""></a>' : '<span></span>') +
          '<a href="' + item.url + '"><strong>' + item.title + '</strong><span>' + item.price + '</span></a>' +
          '<button type="button" data-wishlist-remove="' + item.handle + '">Remove</button>' +
          '</div>';
      }).join('');
    });
  }

  function renderWishlist() {
    var items = getWishlist();
    qsa('[data-wishlist-count]').forEach(function (count) {
      count.textContent = items.length;
    });
    qsa('[data-wishlist-items]').forEach(function (wrap) {
      if (!items.length) {
        wrap.innerHTML = '<div class="wishlist-empty"><p>Your wishlist is empty.</p><a class="ampk-btn ampk-btn--dark" href="/collections/all">Start Shopping</a></div>';
        return;
      }
      wrap.innerHTML = items.map(function (item) {
        return '<div class="wishlist-item" data-wishlist-handle="' + item.handle + '">' +
          (item.image ? '<img src="' + item.image + '" alt="">' : '') +
          '<div><a href="' + item.url + '">' + item.title + '</a><span>' + item.price + '</span>' +
          '<div class="wishlist-item__actions"><button type="button" data-wishlist-move="' + item.handle + '">Move to Bag</button><button type="button" data-wishlist-remove="' + item.handle + '">Remove</button></div></div>' +
          '</div>';
      }).join('');
    });
    qsa('[data-wishlist-toggle]').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      button.classList.toggle('is-active', items.some(function (item) { return item.handle === handle; }));
    });
    renderAccountWishlist();
    removeProductInfoWishlistIcons();
  }

  function initWishlistButtons() {
    qsa('[data-wishlist-toggle]').forEach(function (button) {
      if (button.dataset.wishlistReady) return;
      button.dataset.wishlistReady = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var items = getWishlist();
        var handle = button.getAttribute('data-product-handle');
        var exists = items.some(function (item) { return item.handle === handle; });
        if (exists) {
          items = items.filter(function (item) { return item.handle !== handle; });
        } else {
          items.unshift({
            handle: handle,
            title: button.getAttribute('data-product-title') || '',
            url: button.getAttribute('data-product-url') || ('/products/' + handle),
            image: button.getAttribute('data-product-image') || '',
            price: button.getAttribute('data-product-price') || ''
          });
        }
        setWishlist(items);
        renderWishlist();
        document.body.classList.add('wishlist-open');
      });
    });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      var handle = remove.getAttribute('data-wishlist-remove');
      setWishlist(getWishlist().filter(function (item) { return item.handle !== handle; }));
      renderWishlist();
      return;
    }
    var move = event.target.closest('[data-wishlist-move]');
    if (move) {
      openVariantPicker(move.getAttribute('data-wishlist-move'));
    }
  });

  var activeProductJson;
  var productCache = {};

  function renderVariantPicker(product) {
    var modal = qs('[data-variant-modal]');
    var options = qs('[data-variant-options]', modal);
    if (!modal || !options) return;
    activeProductJson = product;
    modal.removeAttribute('data-selected-variant');
    options.innerHTML = '<div class="variant-modal__product">' + (product.featured_image ? '<img src="' + product.featured_image + '" alt="">' : '') + '<strong>' + product.title + '</strong></div>' +
      '<div class="variant-modal__options">' + product.variants.map(function (variant) {
        var label = variant.title === 'Default Title' ? 'One Size' : variant.title;
        return '<button type="button" class="' + (variant.available ? '' : 'is-unavailable') + '" data-select-variant="' + variant.id + '"' + (variant.available ? '' : ' disabled') + '>' + label + '</button>';
      }).join('') + '</div>' +
      '<button class="variant-modal__apply" type="button" data-variant-apply disabled>Apply</button>';
  }

  function openVariantPicker(handle) {
    var modal = qs('[data-variant-modal]');
    var options = qs('[data-variant-options]', modal);
    if (!modal || !options) return;
    modal.hidden = false;
    options.innerHTML = '<p>Loading sizes...</p>';
    if (productCache[handle]) {
      renderVariantPicker(productCache[handle]);
      return;
    }
    fetch('/products/' + handle + '.js')
      .then(function (response) { return response.json(); })
      .then(function (product) {
        productCache[handle] = product;
        renderVariantPicker(product);
      });
  }

  document.addEventListener('click', function (event) {
    var closeVariant = event.target.closest('[data-variant-close]');
    if (closeVariant) {
      qs('[data-variant-modal]').hidden = true;
      return;
    }
    var selectVariant = event.target.closest('[data-select-variant]');
    if (selectVariant) {
      var variantModal = qs('[data-variant-modal]');
      qsa('[data-select-variant]', variantModal).forEach(function (button) {
        button.classList.toggle('is-selected', button === selectVariant);
      });
      variantModal.setAttribute('data-selected-variant', selectVariant.getAttribute('data-select-variant'));
      var applyButton = qs('[data-variant-apply]', variantModal);
      if (applyButton) applyButton.disabled = false;
      return;
    }
    var applyVariant = event.target.closest('[data-variant-apply]');
    if (applyVariant) {
      var modal = qs('[data-variant-modal]');
      var variantId = modal ? modal.getAttribute('data-selected-variant') : '';
      if (!variantId) return;
      applyVariant.disabled = true;
      applyVariant.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function () {
        return refreshCartDrawer();
      }).then(function () {
        modal.hidden = true;
        document.body.classList.remove('wishlist-open');
        document.body.classList.add('cart-open');
        if (activeProductJson) {
          setWishlist(getWishlist().filter(function (item) { return item.handle !== activeProductJson.handle; }));
          renderWishlist();
        }
      }).catch(function () {
        applyVariant.disabled = false;
        applyVariant.textContent = 'Apply';
      });
    }
  });

  initWishlistButtons();
  renderWishlist();
  removeProductInfoWishlistIcons();
  watchProductInfoWishlistIcons();
  refreshAccountCart();

  qsa('[data-size-chart-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      var modal = qs('[data-size-chart-modal]');
      if (modal) modal.hidden = false;
    });
  });

  qsa('[data-size-chart-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      var modal = qs('[data-size-chart-modal]');
      if (modal) modal.hidden = true;
    });
  });

  qsa('[data-review-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      var modal = qs('[data-review-modal]');
      if (modal) modal.hidden = false;
    });
  });

  qsa('[data-review-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      var modal = qs('[data-review-modal]');
      if (modal) modal.hidden = true;
    });
  });

  qsa('.product-media').forEach(function (mediaWrap) {
    var gallery = qs('.product-gallery', mediaWrap);
    var dotsWrap = qs('[data-product-gallery-dots]', mediaWrap);
    if (!gallery || !dotsWrap) return;

    var slides = qsa('.product-gallery__item', gallery);
    var dots = qsa('[data-product-gallery-dot]', dotsWrap);
    if (slides.length < 2 || dots.length < 2) return;

    function setActiveDot(index) {
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    }

    function currentSlideIndex() {
      var width = gallery.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(gallery.scrollLeft / width)));
    }

    var dotTimer = null;
    gallery.addEventListener('scroll', function () {
      window.clearTimeout(dotTimer);
      dotTimer = window.setTimeout(function () {
        setActiveDot(currentSlideIndex());
      }, 40);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-product-gallery-dot') || '0', 10);
        if (!slides[index]) return;
        gallery.scrollTo({ left: slides[index].offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
        setActiveDot(index);
      });
    });

    setActiveDot(0);
  });

  document.addEventListener('click', function (event) {
    var image = event.target.closest('[data-product-image-open]');
    var modal = qs('[data-product-image-modal]');
    if (image && modal) {
      var modalImage = qs('[data-product-image-modal-img]', modal);
      if (modalImage) {
        modalImage.src = image.getAttribute('data-full-src') || image.currentSrc || image.src;
      }
      modal.hidden = false;
      return;
    }

    if (!modal || modal.hidden) return;
    if (event.target.closest('[data-product-image-close]') || event.target === modal) {
      modal.hidden = true;
      var openImage = qs('[data-product-image-modal-img]', modal);
      if (openImage) openImage.removeAttribute('src');
    }
  });

  qsa('[data-share-product]').forEach(function (button) {
    button.addEventListener('click', function () {
      var shareUrl = button.getAttribute('data-share-url') || window.location.href;
      var shareTitle = button.getAttribute('data-share-title') || document.title;
      if (navigator.share) {
        navigator.share({ title: shareTitle, url: shareUrl });
        return;
      }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(shareUrl);
      }
      button.classList.add('is-copied');
      window.setTimeout(function () { button.classList.remove('is-copied'); }, 1200);
    });
  });

  qsa('[data-instagram-feed]').forEach(function (feed) {
    var endpoint = feed.getAttribute('data-feed-url');
    var profileUrl = feed.getAttribute('data-profile-url') || '#';
    var status = qs('[data-instagram-feed-status]', feed.closest('.instagram-shop'));
    if (!endpoint || !window.fetch) return;

    if (status) {
      status.hidden = false;
      status.textContent = 'Loading latest Instagram posts...';
    }

    function getItems(payload) {
      if (Array.isArray(payload)) return payload;
      if (payload && Array.isArray(payload.data)) return payload.data;
      if (payload && Array.isArray(payload.items)) return payload.items;
      if (payload && Array.isArray(payload.media)) return payload.media;
      return [];
    }

    function renderTile(item) {
      var imageUrl = item.thumbnail_url || item.media_url || item.image || item.url;
      if (!imageUrl) return null;

      var link = item.permalink || item.link || profileUrl;
      var caption = item.caption || 'Instagram look';
      var tile = document.createElement('a');
      var image = document.createElement('img');
      var overlay = document.createElement('span');
      var icon = document.createElement('i');
      var text = document.createElement('span');

      tile.className = 'instagram-shop__tile';
      tile.href = link;
      tile.target = '_blank';
      tile.rel = 'noopener';

      image.src = imageUrl;
      image.alt = caption.slice(0, 110);
      image.loading = 'lazy';

      overlay.className = 'instagram-shop__overlay';
      icon.className = 'ti ti-brand-instagram';
      icon.setAttribute('aria-hidden', 'true');
      text.textContent = 'Shop Look';

      overlay.appendChild(icon);
      overlay.appendChild(text);
      tile.appendChild(image);
      tile.appendChild(overlay);
      return tile;
    }

    fetch(endpoint, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Instagram feed request failed');
        return response.json();
      })
      .then(function (payload) {
        var items = getItems(payload).slice(0, 12);
        var fragment = document.createDocumentFragment();
        items.forEach(function (item) {
          var tile = renderTile(item);
          if (tile) fragment.appendChild(tile);
        });
        if (!fragment.childNodes.length) throw new Error('Instagram feed returned no media');
        feed.innerHTML = '';
        feed.appendChild(fragment);
        if (status) status.hidden = true;
      })
      .catch(function () {
        if (status) {
          status.textContent = 'Latest Instagram feed could not load right now. Showing featured looks.';
        }
      });
  });

  qsa('[data-instagram-ribbon], [data-auto-ribbon]').forEach(function (ribbon) {
    var paused = false;
    var pauseTimer;
    function pauseBriefly() {
      paused = true;
      window.clearTimeout(pauseTimer);
      pauseTimer = window.setTimeout(function () {
        paused = false;
      }, 3500);
    }
    ribbon.addEventListener('pointerdown', pauseBriefly);
    ribbon.addEventListener('mouseenter', function () { paused = true; });
    ribbon.addEventListener('mouseleave', function () { paused = false; });
    window.setInterval(function () {
      if (paused || ribbon.scrollWidth <= ribbon.clientWidth) return;
      var firstTile = ribbon.querySelector('.instagram-shop__tile') || ribbon.firstElementChild;
      var step = firstTile ? firstTile.getBoundingClientRect().width + 12 : ribbon.clientWidth * 0.75;
      if (ribbon.scrollLeft + ribbon.clientWidth >= ribbon.scrollWidth - 8) {
        ribbon.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        ribbon.scrollBy({ left: step, behavior: 'smooth' });
      }
    }, 2600);
  });

  qsa('[data-product-form]').forEach(function (form) {
    var idInput = qs('input[name="id"]', form);
    var variantData = qs('[data-variants-json]', form);
    if (!idInput || !variantData) return;

    var variants = [];
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      variants = [];
    }

    function selectedOptions() {
      return qsa('[data-option-index]', form).map(function (group) {
        var checked = qs('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function variantFits(variant, selected, optionIndex, optionValue) {
      return selected.every(function (value, index) {
        var expected = index === optionIndex ? optionValue : value;
        return !expected || variant.options[index] === expected;
      });
    }

    function updatePillAvailability(selected) {
      qsa('[data-variant-pill]', form).forEach(function (pill) {
        var input = qs('input', pill);
        var stockLabel = qs('[data-stock-label]', pill);
        var optionIndex = parseInt(pill.getAttribute('data-option-position') || '1', 10) - 1;
        var optionValue = pill.getAttribute('data-option-value') || (input ? input.value : '');
        var matches = variants.filter(function (variant) {
          return variantFits(variant, selected, optionIndex, optionValue);
        });
        var available = matches.some(function (variant) { return variant.available; });
        var lowStock = matches.reduce(function (lowest, variant) {
          var quantity = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
          if (!variant.available || quantity === null || quantity < 1 || quantity > 3) return lowest;
          return lowest === null ? quantity : Math.min(lowest, quantity);
        }, null);
        pill.classList.toggle('is-unavailable', !available);
        if (input) input.disabled = !available;
        if (stockLabel) {
          stockLabel.textContent = available && lowStock !== null ? lowStock + ' left' : '';
        }
      });
    }

    function updateVariant() {
      var selected = selectedOptions();
      var match = variants.find(function (variant) {
        return selected.every(function (value, index) {
          return variant.options[index] === value;
        });
      });
      if (match) {
        idInput.value = match.id;
        var addButton = qs('[data-add-to-cart]', form);
        if (addButton) {
          addButton.disabled = !match.available;
          addButton.innerHTML = '<i class="ti ti-shopping-bag"></i> ' + (match.available ? (addButton.getAttribute('data-add-label') || 'ADD TO BAG') : (addButton.getAttribute('data-sold-out-label') || 'SOLD OUT'));
        }
        var buyNow = qs('[data-buy-now]', form);
        if (buyNow) buyNow.disabled = !match.available;
        var productPage = form.closest('.product-page') || document;
        var priceEl = qs('[data-product-current-price]', productPage);
        var compareEl = qs('[data-product-compare-price]', productPage);
        var discountEl = qs('[data-product-discount-percent]', productPage);
        var mrpLabel = qs('[data-product-mrp-label]', productPage);
        var price = parseInt(match.price || 0, 10);
        var compareAtPrice = parseInt(match.compare_at_price || 0, 10);
        if (priceEl) priceEl.textContent = formatMoney(price);
        if (compareAtPrice > price) {
          var percentOff = Math.floor(((compareAtPrice - price) * 100) / compareAtPrice);
          if (compareEl) {
            compareEl.textContent = formatMoney(compareAtPrice);
            compareEl.hidden = false;
          }
          if (discountEl) {
            discountEl.textContent = percentOff + '% OFF';
            discountEl.hidden = false;
          }
          if (mrpLabel) mrpLabel.hidden = false;
        } else {
          if (compareEl) compareEl.hidden = true;
          if (discountEl) discountEl.hidden = true;
          if (mrpLabel) mrpLabel.hidden = true;
        }
      }
      updatePillAvailability(selected);
    }

    qsa('input[type="radio"]', form).forEach(function (radio) {
      radio.addEventListener('change', updateVariant);
    });
    var buyNow = qs('[data-buy-now]', form);
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        if (buyNow.disabled) return;
        buyNow.disabled = true;
        var originalText = buyNow.innerHTML;
        buyNow.innerHTML = 'Processing...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: 1 })
        }).then(function () {
          window.location.href = '/checkout';
        }).catch(function () {
          buyNow.disabled = false;
          buyNow.innerHTML = originalText;
        });
      });
    }
    updateVariant();
  });
})();
